import React from 'react';
import { useTranslation } from 'react-i18next';
import Date from 'components/formaters/Date';
import { CarModel } from 'models/StockModel';


type DateLimiterProps = {
    limit: CarModel['shipDateLimit'],
    br?: boolean,
}

const DateLimiter = ({limit, br}: DateLimiterProps) => {
    const {t} = useTranslation('cars');

    return (
        <>
            {t('export')} {limit!.after ? t('after') : t('before')} {br && <br/>} <Date date={limit!.date}/>
        </>
    );
};

export default DateLimiter;
